import { useSelector } from 'react-redux';

export const useCourseCommentsProps = () => {
  const courses = useSelector(state => state.courses);

  return {
    courses
  }
};
